<div class="dropdown">
    <button type="button" id="expense-search-filter-dropdown" class="btn btn-ms-secondary dropdown-toggle"
        data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
        <fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline" />
        Filter
        @if (filterCount > 0) {
        <span
            class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{filterCount}}</span>
        }
    </button>

    <div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu" (keyup.control.enter)="onApply()">

        <div class="fs-5 fw-bold px-3 py-2">Filter Options</div>

        <div class="separator border-gray-200"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Vendor:</label>
            <input type="text" class="form-control form-control-solid" placeholder="Search vendor"
                [(ngModel)]="vendorInput" (keyup.enter)="onApply()" />
        </div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Reference #:</label>
            <input type="text" class="form-control form-control-solid" placeholder="Search reference number"
                [(ngModel)]="referenceNumberInput" (keyup.enter)="onApply()" />
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Expense Account:</label>
            <ms-chart-of-account-typeahead
                [(ngModel)]="filter().expenseAccount"
                [ngModelOptions]="{standalone: true}"
                [organizationId]="filter().organizationIds?.[0]"
                [categories]="[ChartOfAccountCategory.Expenses]"
                [placeholder]="'All accounts'" />
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Date Paid:</label>
            <div class="row">
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="filter().minimumDatePaid" />
                </div>
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="filter().maximumDatePaid" />
                </div>
            </div>
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Amount:</label>
            <div class="row">
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Min"
                        [(ngModel)]="minimumAmountDisplay" />
                </div>
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Max"
                        [(ngModel)]="maximumAmountDisplay" />
                </div>
            </div>
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Status:</label>
            <ms-multi-select placeholder="Select Status" [options]="selectStatusOptions"
                [(selectedOptions)]="selectedStatuses" (selectionChange)="onStatusChange($event)" />
        </div>

        <div class="d-flex justify-content-end px-3 py-2">
            <button type="button" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
                (click)="onReset()">Reset</button>
            <button type="button" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
        </div>
    </div>
</div>
